import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { BooleanField } from "ui/boolean-field/boolean-field";
import { NavLoader } from "ui/loader";
import { Table, Column } from "ui/table/index";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";

class NetworkListPage extends React.PureComponent {
  static get propTypes() {
    return {
      networks: PropTypes.array.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      venueSyncEnabled: PropTypes.bool.isRequired,
    };
  }

  constructor() {
    super();
  }

  _formatSandboxStatus(s) {
    return s ? "Yes" : "No";
  }

  _formatRemoteUpdates(disabled) {
    return disabled ? "Disabled" : "Enabled";
  }

  _formatRestartSchedule(schedule) {
    if (schedule) {
      if (schedule.startsWith("*")) {
        const t = moment(schedule, "*-H");
        if (t.isValid()) {
          return "Every day, " + t.format("HH:00");
        }
      }

      return moment(schedule, "E-H").format("dddd, HH:00");
    }

    return "None";
  }

  _formatName(name, row) {
    return <Link to={`/networks/${row.id}`}>{name}</Link>;
  }

  _formatUptime(uptime) {
    return uptime ? `${uptime.toFixed(2)}%` : "0.00%";
  }

  _formatSystemManaged(systemManaged) {
    return (
      <BooleanField
        title="Indicates whether network is synced with ad platform."
        uncheckIcon=""
        value={systemManaged}
      />
    );
  }

  _renderView() {
    const { networks, storesLoaded, venueSyncEnabled } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    return (
      <Table data={networks} defaultSorted={[{ dataField: "num_devices", order: "desc" }]} hover pagination search>
        <Column key="id" dataField="id" width="300px" dataSort hidden isKey>
          ID
        </Column>
        <Column
          key="name"
          dataField="name"
          dataFormat={this._formatName}
          dataSort
        >
          Name
        </Column>
        <Column key="num_devices" dataField="num_devices" dataSort>
          Device Count
        </Column>
        <Column
          key="uptime"
          dataField="uptime"
          dataFormat={this._formatUptime}
          dataSort
        >
          Uptime (yesterday)
        </Column>
        <Column
          key="remote_update"
          dataField="device_update_disabled"
          dataFormat={this._formatRemoteUpdates}
          dataSort
        >
          Remote Updates
        </Column>
        <Column
          key="auto_restart"
          dataField="device_restart_time"
          dataFormat={this._formatRestartSchedule}
          dataSort
        >
          Restart Schedule
        </Column>
        <Column
          key="is_sandbox"
          dataField="is_sandbox"
          dataFormat={this._formatSandboxStatus}
          dataSort
        >
          Sandbox
        </Column>
        {venueSyncEnabled && (
          <Column
            key="system_managed"
            dataField="system_managed"
            dataFormat={this._formatSystemManaged}
            dataSort
          >
            Ad Platform Synced
          </Column>
        )}
      </Table>
    );
  }

  render() {
    const view = this._renderView();

    return (
      <Page title="Network List">
        <Box title="" noHeader={true}>
          {view}
        </Box>
      </Page>
    );
  }
}

export { NetworkListPage };
